module.exports = __webpack_public_path__ + "img/gongzhonghaoqrcode.3cabd7ba.jpg";